import React from 'react';
import { useLocation } from 'react-router';
import {
  MenuTabs,
  PMenuTabs,
} from 'src/components/common/tabs/MenuTabs/MenuTabs';
import { APP_ROUTES } from 'src/routing/AppRoutes';
import { useDeviceSizeType } from 'src/utils/hooks/useDeviceType';

type PContactMenuTabs = Pick<PMenuTabs, 'value' | 'onChange' | 'className'>;

export const GuestMenuTabs: React.FC<PContactMenuTabs> = (props) => {
  const { isMobile } = useDeviceSizeType();
  const location = useLocation();
  const tabs = [
    { label: 'Guests', value: APP_ROUTES.GUESTS },
    {
      label: 'Create new guest',
      value: APP_ROUTES.CREATE_GUEST,
      isActive: location.pathname.includes(APP_ROUTES.NEW_GUEST),
    },
    /* { label: 'Upload guest with CSV', value: APP_ROUTES.UPLOAD_GUESTS }, */
  ];
  return (
    <MenuTabs
      tabs={tabs}
      orientation='horizontal'
      {...props}
    />
  );
};
